import React from 'react'
import PropTypes from 'prop-types'
import {
  CircularProgress,
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useTheme,
  useMediaQuery,
} from '@material-ui/core'
import AutocompleteNative from '@material-ui/lab/Autocomplete'
import AddIcon from '@material-ui/icons/Add'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import SaveIcon from '@material-ui/icons/Save'
import { cutMaxLength } from 'utils/helpers'

import { Page, Header, CustomButton, SecaoGenerica, ModalConfirmacao } from 'components'
import { DescricoesVestigiosExame } from 'components/DescricoesVestigiosExame'
import { SelectTextField } from 'components/SelectTextField'
import { FormQuesitos } from 'views/ExamesRealizados/components/FormQuesitos'

import { useExameEficienciaBalistica } from './hooks/useExameEficienciaBalistica'
import { useStyles } from './ExameEficienciaBalistica.styles'

// Importações dos subcomponentes de tabela extraídos
import { LinhaTabelaDescricaoTecnica } from './components/LinhaTabelaDescricaoTecnica'
import { LinhaTabelaExameQuimicoMetalografico } from './components/LinhaTabelaExameQuimicoMetalografico'
import { LinhaTabelaRevelacaoFisicoQuimico } from './components/LinhaTabelaRevelacaoFisicoQuimico'
import { LinhaTabelaColetaPadrao } from './components/LinhaTabelaColetaPadrao'

export const ExameEficienciaBalistica = (props) => {
  const { route } = props
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  const {
    currentUser,
    params,
    descricoesTecnicasDeExame,
    processandoDescricoesTecnicas,
    descricoesHabilitadasParaExameQuimico,
    descricoesHabilitadasParaExtracaoDePadrao,
    casosDoObjetoOrigem,
    locaisGravacoesNumeracaoDeSerie,
    tiposVestigios,
    tiposVestigiosEspecificos,
    descricaoTecnicaSelecionada,
    processandoOperacao,
    processandoAlteracaoRespostas,
    setRespostasQuesitos,

    openAnaliseEficiencia,
    setOpenAnaliseEficiencia,
    openExtracaoPadrao,
    setOpenExtracaoPadrao,
    openAnaliseQuimicoMetalografico,
    setOpenAnaliseQuimicoMetalografico,
    openAnaliseFisicoQuimico,
    setOpenAnaliseFisicoQuimico,

    formExtracao,
    formAnaliseEficiencia,
    formAnaliseQuimicoMetalografico,
    formAnaliseRevelacaoFisicoQuimico,

    isFormExtracaoInvalid,
    isFormEficienciaInvalid,
    isFormQuimicoMetalograficoInvalid,
    isFormAnaliseFisicoQuimicoInvalid,

    handleClickOpenFormularioExtracaoPadrao,
    handleClickOpenFormularioAnaliseConstatacao,
    handleClickOpenFormularioAnaliseQuimicoMetalografico,
    handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico,

    handleConfirmarExtracao,
    handleConfirmarCadastroAnaliseEficiencia,
    handleConfirmarCadastroAnaliseQuimicoMetalografico,
    handleConfirmarCadastroAnaliseFisicoQuimico,
    handleFinalizarExame,
    handleVoltar,
    setAtualizado,
  } = useExameEficienciaBalistica(route)

  const maxLength250 = (newValue) => cutMaxLength(newValue, 250)
  const maxLength4000 = (newValue) => cutMaxLength(newValue, 4000)

  const getLabelResultadoEficiencia = (resultado) => {
    if (!resultado) return ''
    switch (resultado) {
      case 'EFICIENTE':
        return 'Eficiente'
      case 'NAO_EFICIENTE':
        return 'Não eficiente'
      case 'PARCIALMENTE_EFICIENTE':
        return 'Parte testada eficiente e o restante não eficiente'
      case 'NAO_TESTADO':
        return 'Não testado - espoleta percutida e não detonada'
      case 'EFICIENTE_0':
        return 'EFICIENTE - UTILIZAÇÃO DE CARTUCHO DE MUNIÇÃO COMPATÍVEL'
      case 'EFICIENTE_1':
        return 'EFICIENTE - UTILIZAÇÃO DE ESTOJOS DE MUNIÇÃO COMPATÍVEL'
      case 'EFICIENTE_2':
        return 'EFICIENTE - UTILIZAÇÃO DE ELEMENTOS DE MUNIÇÃO PARA RECARGA DA ARMA (ESPOLETA, PÓLVORA, BALINS E BUCHA)'
      case 'EFICIENTE_3':
        return 'EFICIENTE - INSERÇÃO DE CHUMAÇO DE ALGODÃO NA BOCA DO CANO'
      case 'EFICIENTE_4':
        return 'EFICIENTE - UTILIZAÇÃO DE MUNIÇÃO JÁ CONSTANTE DA ARMA DE FOGO'
      case 'EFICIENTE_5':
        return 'EFICIENTE - UTILIZAÇÃO DE ÓLEO PARA DESTRAVAMENTO EM DECORRÊNCIA DE MAU ESTADO DE CONSERVAÇÃO'
      case 'NAO_EFICIENTE_0':
        return 'NÃO EFICIENTE - SEM PRESENÇA DE CHAMINÉ'
      case 'NAO_EFICIENTE_1':
        return 'NÃO EFICIENTE - PERCUTOR DANIFICADO'
      case 'NAO_EFICIENTE_2':
        return 'NÃO EFICIENTE - MECANISMO DE DISPARO DEFEITUOSO'
      case 'NAO_EFICIENTE_3':
        return 'NÃO EFICIENTE - MAU ESTADO DE CONSERVAÇÃO WITH MECANISMO DE DISPARO EMPERRADO'
      case 'NAO_EFICIENTE_4':
        return 'NÃO EFICIENTE - MECANISMO DE DISPARO DEFEITUOSO (SEM FORÇA PARA PRODUÇÃO DE TIRO)'
      case 'PREJUDICADO_0':
        return 'PREJUDICADO - APRESENTAVA-SE MUNICIADA, SEM POSSIBILIDADE DE ANÁLISE DE FORMA SEGURA'
      case 'PREJUDICADO_1':
        return 'PREJUDICADO - TRATA-SE DE AIRSOFT'
      case 'PREJUDICADO_2':
        return 'PREJUDICADO - TRATA-SE DE PISTOLA DE PRESSÃO'
      default:
        return ''
    }
  }

  return (
    <Page className={classes.root} title={`${route.titulo} - SIGEP`}>
      <Header titulo={route.titulo} overline={route.secao} />

      {processandoDescricoesTecnicas ? (
        <div className={classes.carregando}>
          <CircularProgress disableShrink />
        </div>
      ) : (
        <>

          <Grid container className={classes.corpoFormulario}>
            <Grid item sm={12} xs={12} md={12}>
              <DescricoesVestigiosExame
                idExameSolicitado={params.idExameSolicitado}
                idExameRealizado={params.idExameRealizado}
                setAtualizado={setAtualizado}
              />
            </Grid>
          </Grid>

          {/* Seção 2: Análises de Eficiência */}
          <SecaoGenerica titulo="ANÁLISES DE EFICIÊNCIA">
            <Grid container className={classes.corpoFormulario}>
              <Grid item sm={12} xs={12} md={12} className={isMobile ? '' : classes.grupoEspelho}>
                {isMobile ? (
                  descricoesTecnicasDeExame?.length ? (
                    descricoesTecnicasDeExame.map(
                      (descricaoTecnica) =>
                        !['ESTOJO', 'ELEMENTO_MUNICAO', 'CARREGADOR'].includes(
                          descricaoTecnica.tipoVestigioEspecifico
                        ) && (
                          <LinhaTabelaDescricaoTecnica
                            key={descricaoTecnica.id}
                            descricaoTecnica={descricaoTecnica}
                            handleClickOpenFormularioAnaliseConstatacao={
                              handleClickOpenFormularioAnaliseConstatacao
                            }
                            idExameEficiencia={params.idExameRealizado}
                            getLabelResultadoEficiencia={getLabelResultadoEficiencia}
                          />
                        )
                    )
                  ) : (
                    <Typography variant="body2" style={{ textAlign: 'center', padding: '20px' }}>
                      Nenhuma descrição técnica associada a este vestígio
                    </Typography>
                  )
                ) : (
                  <TableContainer className={classes.tableContainer}>
                    <Table aria-label="collapsible table" size="small">
                      <TableHead>
                        <TableRow className={classes.tableHeader}>
                          <TableCell style={{ width: '5%' }} />
                          <TableCell style={{ width: '30%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              DESCRIÇÃO TÉCNICA
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '45%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              RESULTADO DA ANÁLISE DE EFICIÊNCIA
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '20%' }} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {descricoesTecnicasDeExame?.length ? (
                          descricoesTecnicasDeExame.map(
                            (descricaoTecnica) =>
                              !['ESTOJO', 'ELEMENTO_MUNICAO', 'CARREGADOR'].includes(
                                descricaoTecnica.tipoVestigioEspecifico
                              ) && (
                                <LinhaTabelaDescricaoTecnica
                                  key={descricaoTecnica.id}
                                  descricaoTecnica={descricaoTecnica}
                                  handleClickOpenFormularioAnaliseConstatacao={
                                    handleClickOpenFormularioAnaliseConstatacao
                                  }
                                  idExameEficiencia={params.idExameRealizado}
                                  getLabelResultadoEficiencia={getLabelResultadoEficiencia}
                                />
                              )
                          )
                        ) : (
                          <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                            <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                              <Typography variant="body2">
                                Nenhuma descrição técnica associada a este vestígio
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </SecaoGenerica>

          {/* Seção 3: Exame Químico-Metalográfico */}
          <SecaoGenerica titulo="EXAME QUÍMICO-METALOGRÁFICO">
            <Grid container className={classes.corpoFormulario}>
              <Grid item sm={12} xs={12} md={12} className={isMobile ? '' : classes.grupoEspelho}>
                {isMobile ? (
                  descricoesHabilitadasParaExameQuimico?.length ? (
                    descricoesHabilitadasParaExameQuimico.map((descricaoVestigioBalistico) => (
                      <LinhaTabelaExameQuimicoMetalografico
                        key={descricaoVestigioBalistico.id}
                        descricaoVestigioBalistico={descricaoVestigioBalistico}
                        handleClickOpenFormularioAnaliseExameQuimicoMetalografico={
                          handleClickOpenFormularioAnaliseQuimicoMetalografico
                        }
                        idExameRealizado={params.idExameRealizado}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" style={{ textAlign: 'center', padding: '20px' }}>
                      Nenhuma descrição técnica habilitada para este exame
                    </Typography>
                  )
                ) : (
                  <TableContainer className={classes.tableContainer}>
                    <Table aria-label="collapsible table" size="small">
                      <TableHead>
                        <TableRow className={classes.tableHeader}>
                          <TableCell style={{ width: '5%' }} />
                          <TableCell style={{ width: '30%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              DESCRIÇÃO TÉCNICA
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '45%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              RESULTADO DO EXAME QUÍMICO-METALOGRÁFICO
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '20%' }} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {descricoesHabilitadasParaExameQuimico?.length ? (
                          descricoesHabilitadasParaExameQuimico.map((descricaoVestigioBalistico) => (
                            <LinhaTabelaExameQuimicoMetalografico
                              key={descricaoVestigioBalistico.id}
                              descricaoVestigioBalistico={descricaoVestigioBalistico}
                              handleClickOpenFormularioAnaliseExameQuimicoMetalografico={
                                handleClickOpenFormularioAnaliseQuimicoMetalografico
                              }
                              idExameRealizado={params.idExameRealizado}
                            />
                          ))
                        ) : (
                          <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                            <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                              <Typography variant="body2">
                                Nenhuma descrição técnica habilitada para este exame
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </SecaoGenerica>

          {/* Seção 4: Exame de Revelação Físico-Químico */}
          <SecaoGenerica titulo="EXAME DE REVELAÇÃO FÍSICO-QUÍMICO">
            <Grid container className={classes.corpoFormulario}>
              <Grid item sm={12} xs={12} md={12} className={isMobile ? '' : classes.grupoEspelho}>
                {isMobile ? (
                  descricoesHabilitadasParaExameQuimico?.length ? (
                    descricoesHabilitadasParaExameQuimico.map((descricaoVestigioBalistico) => (
                      <LinhaTabelaRevelacaoFisicoQuimico
                        key={descricaoVestigioBalistico.id}
                        descricaoVestigioBalistico={descricaoVestigioBalistico}
                        handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico={
                          handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico
                        }
                        idExameRealizado={params.idExameRealizado}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" style={{ textAlign: 'center', padding: '20px' }}>
                      Nenhuma descrição técnica habilitada para este exame
                    </Typography>
                  )
                ) : (
                  <TableContainer className={classes.tableContainer}>
                    <Table aria-label="collapsible table" size="small">
                      <TableHead>
                        <TableRow className={classes.tableHeader}>
                          <TableCell style={{ width: '5%' }} />
                          <TableCell style={{ width: '30%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              DESCRIÇÃO TÉCNICA
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '45%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              RESULTADO DO EXAME DE REVELAÇÃO
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '20%' }} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {descricoesHabilitadasParaExameQuimico?.length ? (
                          descricoesHabilitadasParaExameQuimico.map((descricaoVestigioBalistico) => (
                            <LinhaTabelaRevelacaoFisicoQuimico
                              key={descricaoVestigioBalistico.id}
                              descricaoVestigioBalistico={descricaoVestigioBalistico}
                              handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico={
                                handleClickOpenFormularioAnaliseRevelacaoFisicoQuimico
                              }
                              idExameRealizado={params.idExameRealizado}
                            />
                          ))
                        ) : (
                          <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                            <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                              <Typography variant="body2">
                                Nenhuma descrição técnica habilitada para este exame
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </SecaoGenerica>

          {/* Seção 5: Exame de Coleta de Padrões */}
          <SecaoGenerica titulo="EXAME DE COLETA DE PADRÕES">
            <Grid container className={classes.corpoFormulario}>
              <Grid item sm={12} xs={12} md={12} className={isMobile ? '' : classes.grupoEspelho}>
                {isMobile ? (
                  descricoesHabilitadasParaExtracaoDePadrao?.length ? (
                    descricoesHabilitadasParaExtracaoDePadrao.map((descricaoTecnica) => (
                      <LinhaTabelaColetaPadrao
                        key={descricaoTecnica.id}
                        descricaoTecnica={descricaoTecnica}
                        handleClickOpenFormularioExtracaoPadrao={
                          handleClickOpenFormularioExtracaoPadrao
                        }
                        idExameRealizado={params.idExameRealizado}
                      />
                    ))
                  ) : (
                    <Typography variant="body2" style={{ textAlign: 'center', padding: '20px' }}>
                      Nenhuma descrição técnica habilitada para este exame
                    </Typography>
                  )
                ) : (
                  <TableContainer className={classes.tableContainer}>
                    <Table aria-label="collapsible table" size="small">
                      <TableHead>
                        <TableRow className={classes.tableHeader}>
                          <TableCell style={{ width: '5%' }} />
                          <TableCell style={{ width: '30%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              DESCRIÇÃO TÉCNICA
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '45%' }}>
                            <Typography style={{ fontSize: '13px', fontWeight: 'bold' }}>
                              EXTRAÇÃO DE VESTÍGIO
                            </Typography>
                          </TableCell>
                          <TableCell style={{ width: '20%' }} />
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {descricoesHabilitadasParaExtracaoDePadrao?.length ? (
                          descricoesHabilitadasParaExtracaoDePadrao.map((descricaoTecnica) => (
                            <LinhaTabelaColetaPadrao
                              key={descricaoTecnica.id}
                              descricaoTecnica={descricaoTecnica}
                              handleClickOpenFormularioExtracaoPadrao={
                                handleClickOpenFormularioExtracaoPadrao
                              }
                              idExameRealizado={params.idExameRealizado}
                            />
                          ))
                        ) : (
                          <TableRow className={classes.tableRow} style={{ width: '100%' }}>
                            <TableCell colSpan={6} style={{ textAlign: 'center', padding: '20px' }}>
                              <Typography variant="body2">
                                Nenhuma descrição técnica habilitada para este exame
                              </Typography>
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}
              </Grid>
            </Grid>
          </SecaoGenerica>

          {/* Seção 6: Respostas dos Quesitos */}
          <SecaoGenerica titulo="RESPOSTAS DOS QUESITOS">
            <Grid container className={classes.corpoFormulario}>
              <Grid
                item
                sm={12}
                xs={12}
                md={12}
                className={classes.grupoEspelho}
                style={{ borderBottom: 'none' }}
              >
                <FormQuesitos
                  idExameRealizado={params.idExameRealizado}
                  setRespostasComponentePai={setRespostasQuesitos}
                />
              </Grid>
            </Grid>
          </SecaoGenerica>

          <Divider className={classes.divider} />

          {/* Barra inferior de navegação */}
          <Grid
            container
            justifyContent="space-between"
            spacing={1}
            className={classes.navigationContainer}
          >
            <Grid item>
              <CustomButton variant="outlined" onClick={handleVoltar} startIcon={<ArrowBackIcon />}>
                Voltar
              </CustomButton>
            </Grid>
            <Grid item>
              <CustomButton
                variant="contained"
                color="primary"
                onClick={handleFinalizarExame}
                isLoading={processandoAlteracaoRespostas}
                startIcon={<SaveIcon />}
              >
                Finalizar
              </CustomButton>
            </Grid>
          </Grid>
        </>
      )}

      {/* --- FORMULÁRIOS MODAIS (MODAL CONFIRMAÇÃO) --- */}

      {/* 1. Modal Análise de Eficiência */}
      <ModalConfirmacao
        aberto={openAnaliseEficiencia}
        onClose={() => setOpenAnaliseEficiencia(false)}
        onConfirm={handleConfirmarCadastroAnaliseEficiencia}
        disabled={isFormEficienciaInvalid}
        processando={processandoOperacao}
        titulo="FORMULÁRIO DE ANÁLISE DE EFICIÊNCIA"
        confirmarColor="primary"
      >
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <AutocompleteNative
              value={formAnaliseEficiencia.formState.values.resultado || null}
              name="resultado"
              noOptionsText="Sem informações"
              options={
                ['ARMA_DE_FOGO', 'ARMA_DE_PRESSAO'].includes(descricaoTecnicaSelecionada?.tipoVestigioEspecifico)
                  ? [
                    'EFICIENTE_0',
                    'EFICIENTE_1',
                    'EFICIENTE_2',
                    'EFICIENTE_3',
                    'EFICIENTE_4',
                    'EFICIENTE_5',
                    'NAO_EFICIENTE_0',
                    'NAO_EFICIENTE_1',
                    'NAO_EFICIENTE_2',
                    'NAO_EFICIENTE_3',
                    'NAO_EFICIENTE_4',
                    'PREJUDICADO_0',
                    'PREJUDICADO_1',
                    'PREJUDICADO_2',
                  ]
                  : ['EFICIENTE', 'NAO_EFICIENTE', 'PARCIALMENTE_EFICIENTE', 'NAO_TESTADO']
              }
              onChange={(event, newValue) =>
                formAnaliseEficiencia.handleChangeNewValueByNameProperty(event, newValue, 'resultado')
              }
              getOptionLabel={getLabelResultadoEficiencia}
              renderOption={getLabelResultadoEficiencia}
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  placeholder="Selecionar..."
                  variant="outlined"
                  label="RESULTADO DA ANÁLISE"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={formAnaliseEficiencia.hasError('resultado')}
                  helperText={
                    formAnaliseEficiencia.hasError('resultado')
                      ? formAnaliseEficiencia.formState.errors.resultado[0]
                      : null
                  }
                />
              )}
            />
          </Grid>
        </Grid>
      </ModalConfirmacao>

      {/* 2. Modal Extração de Padrão */}
      <ModalConfirmacao
        aberto={openExtracaoPadrao}
        onClose={() => setOpenExtracaoPadrao(false)}
        onConfirm={handleConfirmarExtracao}
        disabled={isFormExtracaoInvalid}
        processando={processandoOperacao}
        titulo="FORMULÁRIO DE EXTRAÇÃO DE PADRÃO"
        confirmarColor="primary"
        maxWidth="md"
      >
        <Grid container spacing={2} className={classes.containerCampos}>
          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="subtitle2">
              <b>DADOS DA EMBALAGEM</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>

          <Grid
            item
            container
            justifyContent="space-between"
            alignItems="center"
            className={classes.fieldGroup}
            spacing={2}
          >
            <Grid item md={6} sm={6} xs={12} className={classes.field}>
              <TextField
                id="lacre"
                error={formExtracao.hasError('lacre')}
                label="NÚMERO DO LACRE"
                fullWidth
                helperText={formExtracao.hasError('lacre') ? formExtracao.formState.errors.lacre[0] : null}
                variant="outlined"
                name="lacre"
                onChange={(e) => formExtracao.handleChangeWithModification(e, maxLength250)}
                value={formExtracao.formState.values.lacre || ''}
                required
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <Typography variant="caption">
                Caracteres restantes:{' '}
                {250 - (formExtracao.formState.values.lacre?.length || 0)}
              </Typography>
            </Grid>

            <Grid item container md={12} sm={12} xs={12} spacing={1}>
              <Grid item md={12} sm={12} xs={12}>
                <Typography variant="body2">TIPO DA EMBALAGEM *</Typography>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <FormControl component="fieldset" fullWidth>
                  <RadioGroup
                    aria-label="tipo-embalagem"
                    name="tipoEmbalagem"
                    value={formExtracao.formState.values.tipoEmbalagem || ''}
                    onChange={formExtracao.handleChange}
                    style={{ display: 'flex', flexDirection: 'row' }}
                  >
                    <FormControlLabel
                      value="SACO LACRE"
                      control={<Radio />}
                      label={<Typography variant="body2">SACO LACRE</Typography>}
                    />
                    <FormControlLabel
                      value="PLÁSTICO"
                      control={<Radio />}
                      label={<Typography variant="body2">PLÁSTICO</Typography>}
                    />
                    <FormControlLabel
                      value="ENVELOPE PAPEL"
                      control={<Radio />}
                      label={<Typography variant="body2">ENVELOPE DE PAPEL</Typography>}
                    />
                    <FormControlLabel
                      value="CAIXA"
                      control={<Radio />}
                      label={<Typography variant="body2">CAIXA</Typography>}
                    />
                    <FormControlLabel
                      value="AUSENTE"
                      control={<Radio />}
                      label={<Typography variant="body2">AUSENTE</Typography>}
                    />
                    <FormControlLabel
                      value="OUTRO"
                      control={<Radio />}
                      label={<Typography variant="body2">OUTRO</Typography>}
                    />
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <TextField
                  label="OUTRO TIPO DE EMBALAGEM"
                  name="outroTipoEmbalagem"
                  variant="outlined"
                  value={formExtracao.formState.values.outroTipoEmbalagem || ''}
                  onChange={formExtracao.handleChange}
                  disabled={formExtracao.formState.values.tipoEmbalagem !== 'OUTRO'}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item md={12} sm={12} xs={12} style={{ marginTop: 16 }}>
            <Typography variant="subtitle2">
              <b>CARACTERÍSTICAS DO VESTÍGIO</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>
          <Grid item md={12} sm={12} xs={12} className={classes.field}>
            <TextField
              variant="outlined"
              label="DESCRIÇÃO"
              multiline
              minRows={5}
              required
              fullWidth
              value={formExtracao.formState.values.descricao || ''}
              InputLabelProps={{
                shrink: true,
                className: classes.labelInput,
              }}
              name="descricao"
              onChange={(e) => formExtracao.handleChangeWithModification(e, maxLength4000)}
              error={formExtracao.hasError('descricao')}
              helperText={
                formExtracao.hasError('descricao') ? formExtracao.formState.errors.descricao[0] : null
              }
            />
            <Typography variant="caption">
              Caracteres restantes:{' '}
              {4000 - (formExtracao.formState.values.descricao?.length || 0)}
            </Typography>
          </Grid>

          <Grid item md={12} sm={12} xs={12}>
            <Typography variant="subtitle2">
              <b>CUSTÓDIA INICIAL</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>

          <Grid item container justifyContent="space-between" alignItems="center" spacing={2}>
            <Grid item md={12} sm={12} xs={12} className={classes.field}>
              <AutocompleteNative
                name="setorAtual"
                value={formExtracao.formState.values.setorAtual || null}
                noOptionsText="Sem informações"
                options={currentUser && currentUser.setores ? currentUser.setores : []}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) =>
                  formExtracao.handleChangeNewValueByNameProperty(event, newValue, 'setorAtual')
                }
                getOptionLabel={(option) =>
                  `${option.nome?.toUpperCase()} - ${option.sigla} / ${option.divisao?.regional?.nome?.toUpperCase()}`
                }
                renderOption={(option) =>
                  `${option.nome?.toUpperCase()} - ${option.sigla} / ${option.divisao?.regional?.nome?.toUpperCase()}`
                }
                renderInput={(paramsInput) => (
                  <TextField
                    {...paramsInput}
                    variant="outlined"
                    placeholder="SELECIONAR..."
                    label="SETOR INICIAL DO VESTÍGIO (A LISTA CONTÉM OS SETORES QUE VOCÊ FAZ PARTE)"
                    required
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid item md={12} sm={12} xs={12} style={{ marginTop: 16 }}>
            <Typography variant="subtitle2">
              <b>CASO A SER INSERIDO</b>
            </Typography>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <Divider className={classes.dividerTitle} />
          </Grid>

          <Grid item container justifyContent="space-between" alignItems="center" spacing={2}>
            <Grid item md={12} sm={12} xs={12} className={classes.field}>
              <AutocompleteNative
                name="caso"
                value={formExtracao.formState.values.caso || null}
                noOptionsText="Sem informações"
                options={casosDoObjetoOrigem || []}
                getOptionSelected={(option, value) => option.id === value.id}
                onChange={(event, newValue) =>
                  formExtracao.handleChangeNewValueByNameProperty(event, newValue, 'caso')
                }
                getOptionLabel={(option) => `${option.identificador?.toUpperCase()}`}
                renderOption={(option) => `${option.identificador?.toUpperCase()}`}
                renderInput={(paramsInput) => (
                  <TextField
                    {...paramsInput}
                    variant="outlined"
                    placeholder=""
                    required
                    label="SELECIONE O CASO"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      </ModalConfirmacao>

      {/* 3. Modal Exame Químico-Metalográfico */}
      <ModalConfirmacao
        aberto={openAnaliseQuimicoMetalografico}
        onClose={() => setOpenAnaliseQuimicoMetalografico(false)}
        onConfirm={handleConfirmarCadastroAnaliseQuimicoMetalografico}
        disabled={isFormQuimicoMetalograficoInvalid}
        processando={processandoOperacao}
        titulo="FORMULÁRIO DE EXAME QUÍMICO-METALOGRÁFICO"
        confirmarColor="primary"
      >
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <AutocompleteNative
              value={formAnaliseQuimicoMetalografico.formState.values.resultado || null}
              name="resultado"
              noOptionsText="Sem informações"
              options={['POSITIVO', 'NEGATIVO']}
              onChange={(event, newValue) =>
                formAnaliseQuimicoMetalografico.handleChangeNewValueByNameProperty(
                  event,
                  newValue,
                  'resultado'
                )
              }
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  placeholder="Selecionar..."
                  variant="outlined"
                  label="RESULTADO DA ANÁLISE"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={formAnaliseQuimicoMetalografico.hasError('resultado')}
                  helperText={
                    formAnaliseQuimicoMetalografico.hasError('resultado')
                      ? formAnaliseQuimicoMetalografico.formState.errors.resultado[0]
                      : null
                  }
                />
              )}
            />
          </Grid>
          {formAnaliseQuimicoMetalografico.formState.values.resultado === 'POSITIVO' && (
            <>
              <Grid item md={12} sm={12} xs={12}>
                <TextField
                  label="NÚMERO DE SÉRIE"
                  name="numeroSerie"
                  variant="outlined"
                  value={formAnaliseQuimicoMetalografico.formState.values.numeroSerie || ''}
                  onChange={formAnaliseQuimicoMetalografico.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <SelectTextField
                  form={formAnaliseQuimicoMetalografico}
                  prop="locGravs"
                  label="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE"
                  propInput="localGravacaoNumeracaoSerieInput"
                  labelInput="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE (ESPECIFICAR)"
                  options={locaisGravacoesNumeracaoDeSerie}
                  multiple
                  isValoresObjeto
                />
              </Grid>
            </>
          )}
        </Grid>
      </ModalConfirmacao>

      {/* 4. Modal Exame de Revelação Físico-Químico */}
      <ModalConfirmacao
        aberto={openAnaliseFisicoQuimico}
        onClose={() => setOpenAnaliseFisicoQuimico(false)}
        onConfirm={handleConfirmarCadastroAnaliseFisicoQuimico}
        disabled={isFormAnaliseFisicoQuimicoInvalid}
        processando={processandoOperacao}
        titulo="FORMULÁRIO DE EXAME DE REVELAÇÃO FÍSICO-QUÍMICO"
        confirmarColor="primary"
      >
        <Grid container spacing={2}>
          <Grid item md={12} sm={12} xs={12}>
            <AutocompleteNative
              value={formAnaliseRevelacaoFisicoQuimico.formState.values.resultado || null}
              name="resultado"
              noOptionsText="Sem informações"
              options={['POSITIVO', 'NEGATIVO']}
              onChange={(event, newValue) =>
                formAnaliseRevelacaoFisicoQuimico.handleChangeNewValueByNameProperty(
                  event,
                  newValue,
                  'resultado'
                )
              }
              renderInput={(paramsInput) => (
                <TextField
                  {...paramsInput}
                  placeholder="Selecionar..."
                  variant="outlined"
                  label="RESULTADO DA ANÁLISE"
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                  error={formAnaliseRevelacaoFisicoQuimico.hasError('resultado')}
                  helperText={
                    formAnaliseRevelacaoFisicoQuimico.hasError('resultado')
                      ? formAnaliseRevelacaoFisicoQuimico.formState.errors.resultado[0]
                      : null
                  }
                />
              )}
            />
          </Grid>
          {formAnaliseRevelacaoFisicoQuimico.formState.values.resultado === 'POSITIVO' && (
            <>
              <Grid item md={12} sm={12} xs={12}>
                <TextField
                  label="NÚMERO DE SÉRIE"
                  name="numeroSerie"
                  variant="outlined"
                  value={formAnaliseRevelacaoFisicoQuimico.formState.values.numeroSerie || ''}
                  onChange={formAnaliseRevelacaoFisicoQuimico.handleChange}
                  fullWidth
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <Grid item md={12} sm={12} xs={12}>
                <SelectTextField
                  form={formAnaliseRevelacaoFisicoQuimico}
                  prop="locGravs"
                  label="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE"
                  propInput="localGravacaoNumeracaoSerieInput"
                  labelInput="LOCAL DE GRAVAÇÃO DA NUMERAÇÃO DE SÉRIE (ESPECIFICAR)"
                  options={locaisGravacoesNumeracaoDeSerie}
                  multiple
                  isValoresObjeto
                />
              </Grid>
            </>
          )}
        </Grid>
      </ModalConfirmacao>
    </Page>
  )
}

ExameEficienciaBalistica.propTypes = {
  route: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    secao: PropTypes.string.isRequired,
    tipoExame: PropTypes.string.isRequired,
  }).isRequired,
}
